import { Input, Label } from "reactstrap";
import { Brand } from "../../../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../../../reduxToolkit/hooks";
import { addNewBrand, removeBrand } from "../../../../../../reduxToolkit/reducers/eCommerce/filterSlice";
import { getBrands } from "../../../../../../utils/ecommerce";

// This component renders a checkbox for each brand in the product item.
const BrandFilter = () => {

  const { productItem } = useAppSelector((state) => state.product);
  const brands = getBrands(productItem);
  const { filter } = useAppSelector((state) => state.filterData);
  const dispatch = useAppDispatch();

  const handleBrands = (event: React.ChangeEvent<HTMLInputElement>, category: string[]) => {
    const index = brands.indexOf(event.target.value);
    if (event.target.checked === true) dispatch(addNewBrand(event.target.value));
    else dispatch(removeBrand({ index, category }));
  };

  return (
    <div className="product-filter">
      <h4 className="mb-1">{Brand}</h4>
      <div className="checkbox-animated mt-0">
        {brands.map((brand, index) => (
          <Label className="d-block" key={index}>
            <Input className="checkbox_animated" onChange={(e) => handleBrands(e, filter.category)} value={brand} defaultChecked={filter.brand.includes(brand) ? true : false} type="checkbox" />
            {brand}
          </Label>
        ))}
      </div>
    </div>
  );
};

export default BrandFilter;